// // import React, { useEffect } from 'react';
// // import { useMsal } from '@azure/msal-react';
// // import { loginRequest } from '../Auth/authConfig';

// // function MicrosoftLoginRedirect() {
// //   const { instance } = useMsal();

// //   useEffect(() => {
// //     instance.loginRedirect(loginRequest);
// //   }, [instance]);

// //   return (
// //     <div className="h-screen flex items-center justify-center">
// //       <p>Redirecting to MIS login...</p>
// //     </div>
// //   );
// // }

// // export default MicrosoftLoginRedirect;

// import React, { useEffect } from 'react';
// import { useMsal } from '@azure/msal-react';
// import { loginRequest } from './authConfig';

// function MicrosoftLoginRedirect() {
//   const { instance } = useMsal();

//   useEffect(() => {
//     instance
//       .handleRedirectPromise()
//       .then((response) => {
//         if (response) {
//           // ✅ Successful login, store session and redirect
//         //   sessionStorage.setItem("auth", "true");
//           window.location.href = "/login";
//         } else {
//           // 🔁 Not logged in yet, trigger login
//           instance.loginRedirect(loginRequest);
//         }
//       })
//       .catch((error) => {
//         console.error("❌ MSAL Redirect Error:", error);
//       });
//   }, [instance]);

//   return (
//     <div className="h-screen flex items-center justify-center">
//       <p>Redirecting to MIS login...</p>
//     </div>
//   );
// }

// export default MicrosoftLoginRedirect;


import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../Auth/authConfig';

function MicrosoftLoginRedirect() {
  const { instance } = useMsal();

  useEffect(() => {
    instance.handleRedirectPromise()
      .then((response) => {
        if (response) {
          // ✅ MSAL login succeeded — flag it
          sessionStorage.setItem("msalLogin", "true");
          window.location.href = "/login";
        } else {
          // 🔁 Not yet logged in — start login
          instance.loginRedirect(loginRequest);
        }
      })
      .catch((error) => {
        console.error("❌ MSAL Redirect Error:", error);
      });
  }, [instance]);

  return (
    <div className="h-screen flex items-center justify-center">
      <p>Redirecting to MIS login...</p>
    </div>
  );
}

export default MicrosoftLoginRedirect;
